import { render, staticRenderFns } from "./detail-dynamic.vue?vue&type=template&id=57e70961&scoped=true"
import script from "./detail-dynamic.vue?vue&type=script&lang=js"
export * from "./detail-dynamic.vue?vue&type=script&lang=js"
import style0 from "./detail-dynamic.vue?vue&type=style&index=0&id=57e70961&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e70961",
  null
  
)

export default component.exports